export const WATCHLIST_QUALIFIER_LABELS = {
  trend_continuation_up:   { label: 'Trend Continuation: Up',   badgeClass: 'bg-success' },
  trend_continuation_down: { label: 'Trend Continuation: Down', badgeClass: 'bg-danger' },
  range_high_breakout: { label: 'Range High: Breakout', badgeClass: 'bg-success' },
  range_high_reversal: { label: 'Range High: Reversal', badgeClass: 'bg-danger' },
  range_low_breakdown: { label: 'Range Low: Breakdown', badgeClass: 'bg-danger' },
  range_low_reversal:  { label: 'Range Low: Reversal',  badgeClass: 'bg-success' },
  news_positive:     { label: 'Positive News',     badgeClass: 'bg-success' },
  news_negative:     { label: 'Negative News',     badgeClass: 'bg-danger' },
  earnings_today:    { label: 'Earnings Today',    badgeClass: 'bg-warning text-dark' },
  earnings_tomorrow: { label: 'Earnings Tomorrow', badgeClass: 'bg-info text-dark' },
  user_suggested:    { label: 'User Suggested',    badgeClass: 'bg-primary' },
}

export function getQualifierMeta(qualifierType) {
  return (
    WATCHLIST_QUALIFIER_LABELS[qualifierType] || {
      label: qualifierType || 'Unknown',
      badgeClass: 'bg-secondary',
    }
  )
}

// Internal direction vocabulary ("up"/"down") mapped to display metadata.
export const WATCHLIST_DIRECTION_LABELS = {
  up:   { label: 'Bullish', badgeClass: 'bg-success-subtle text-success border border-success-subtle' },
  down: { label: 'Bearish', badgeClass: 'bg-danger-subtle text-danger border border-danger-subtle' },
}

export function getDirectionMeta(direction) {
  return WATCHLIST_DIRECTION_LABELS[direction] || null
}
